<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Joshua
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that God is both willing and able to keep all his promises.
                        </li>
                        <li>
                            To understand that God promises to rescue everyone who asks in faith to be saved.
                        </li>
                        <li>
                            To understand that true faith is expressed in obedience to God’s word and repentance when we disobey.
                        </li>
                        <li>
                            To understand that God will reward all those who trust his promises and obey his word.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series consists of five lessons, each of them focusing on a different character
                        (Rahab, Israel, Achan, Caleb and Joshua).
                        Together they highlight two major themes in the book:
                    </p>

                    <ul>
                        <li>
                            Faith – God saves people by faith alone; anyone may be saved simply by
                            trusting in his eternal rescue plan (weeks 1, 2 and 3). God is worthy of
                            our trust because he always keeps his promises to save and bless his people
                            (weeks 2, 3, 4 and 5).
                        </li>
                        <li>
                            Obedience – Faith always leads to obedience to God’s word; this is true
                            both for salvation (week 1) and for daily life (weeks 2, 4 and 5).
                            Disobedience has serious consequences, but genuine faith will bring
                            repentance and forgiveness (week 3).
                        </li>
                    </ul>

                    <p>
                        Faith and obedience must go together.
                        Without fruitful obedience, faith is dead; without faith, obedience
                        is merely works-based religion. Joshua teaches clearly that no-one
                        may be saved by any other means than
                        God’s grace, but that trusting God’s promises will always mean acting on them.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Rahab's Request (Joshua 1:1-2:24)
                    </p>
                    <p>
                        Lesson 2 - Israel's Faith (Joshua 5:13-6:27)
                    </p>
                    <p>
                        Lesson 3 - Achan's Sin (Joshua 7:1-8:35)
                    </p>
                    <p>
                        Lesson 4 - Caleb's Reward (Joshua 14:6-15)
                    </p>
                    <p>
                        Lesson 5 - Joshua's Choice (Joshua 24:1-28)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Joshua",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Joshua`,
             meta: [
                {
                    name: 'description',
                    content: "To understand that God is both willing and able to keep all his promises.",
                },
            ],
        };
    },
};
</script>
